import { COLORS } from '../../config/colors/colors';
import { styled } from 'goober';
import { Typography } from '../typography/typography';
import { Tooltip } from '@vtbhome/juicyfront';

export const Wrapper = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    border-radius: 8px;
    border: 1px solid ${COLORS.neutral_20};
`;

export const Header = styled('div')`
    display: flex;
    gap: 16px;
`;

export const StyledTooltip = styled(Tooltip)`
    height: fit-content;
    margin-right: auto;
    flex-direction: column;
    gap: 16px;
`;

export const InitiatorWrapper = styled('div')`
    display: flex;
    gap: 4px;
    flex-direction: column;
    align-items: flex-start;
`;

export const RequestInfo = styled('div')`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 100%;
`;

export const Title = styled(Typography)`
    margin-top: 8px;
`;

export const TagsWrapper = styled('div')`
    display: flex;
    gap: 8px;
    margin-top: 12px;
`;

export const InfoGroup = styled('div')`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
`;
